// supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL;     // ← remove "!"
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY; // ← remove "!"

// 🔍 DEBUG
console.log("⚙️ Supabase URL:", supabaseUrl);
console.log(
  "🔑 Supabase Key:",
  supabaseAnonKey ? supabaseAnonKey.slice(0, 6) + "…" : supabaseAnonKey
);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,     // store your JWT in localStorage
    autoRefreshToken: true,   // keep it fresh
    detectSessionInUrl: true, // for magic‑link flows
  },
});
